// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__8Vtrp","Header--short":"Header_Header--short__Qr6pX","Header--NavbarOnly":"Header_Header--NavbarOnly__yaR4q"};